module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('uploader', {
    on: {
      "on-upload": _vm.upload
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74748a20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/img-uploader/demo.vue
// module id = 267
// module chunks = 17